const menu = [
	{
		icone: 'person',
		nome: 'Meu perfil',
		path: '/perfil'
	}
];

export default menu;
